import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Steps } from '../models/trakingObjects';
import { MatDialog } from '@angular/material/dialog';
import { ReviewOrderModalComponent } from '../review-order-modal/review-order-modal.component';



@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.css']
})
export class StepperComponent {
  @Input() currentStep: number = 0;
  @Input() sale_id: string | any = "";
  @Input() steps: Steps[] = [];
  @Output() openModal = new EventEmitter<any>();
  progressWidth: number = 0;
  constructor() { }

  ngOnInit() {
    this.updateProgressWidth();
  }

  openReviewModal(event) {
    console.log('event in stepper', event)
    this.openModal.emit({ ...event, sale_id: this.sale_id, })
  }

  goToStep(index: number) {
    this.currentStep = index;
    this.updateProgressWidth();
  }

  updateProgressWidth() {
    this.progressWidth = (this.currentStep / (this.steps.length - 1)) * 100;
  }
}
